export class Client {
  id?: string;
  client_id?: string;
  require_employee_id_enabled?: boolean;
  unique_employee_id_enabled?: boolean;
  name: string;
  status: string;
}
